function isCIBCCreditCard(cardInfo) {
    return !!cardInfo.bank.match(/cibc|simplii/i);
}

export default isCIBCCreditCard;
